// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2.MobileSearchMessaging{color:#666;display:inline-block;font-family:"UbuntuBold",Arial,Helvetica,sans-serif;font-size:14px;margin-bottom:0;padding:5px}h2.MobileSearchMessaging a{color:var(--wl-href-color, #0c6a93);text-decoration:none}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
